import { produce } from 'immer';
export const mutations = {
  init: ({
    state
  }) => _ => {
    return state;
  },
  create: ({
    project
  }) => state => {
    return {
      ...state,
      project: {
        ...state.project,
        ...project
      }
    };
  },
  edit: ({
    changes
  }) => state => {
    if ('project' in changes) {
      return produce(state, draft => {
        draft.project = {
          ...draft.project,
          ...changes.project
        };
      });
    }
    return produce(state, draft => {
      Object.assign(draft, changes);
    });
  },
  subject: {
    add: subject => state => {
      return produce(state, draft => {
        draft.subjects.push(subject);
      });
    },
    delete: ({
      id
    }) => state => {
      const truncated = state.subjects.filter(s => s.id !== id);
      return {
        ...state,
        subjects: truncated
      };
    },
    edit: ({
      id,
      changes
    }) => state => {
      const existing = state.subjects.find(s => s.id === id);
      if (!existing) {
        return state;
      }
      const changed = {
        ...existing,
        ...changes
      };
      const subjects = state.subjects.map(s => s.id === id ? changed : s);
      return {
        ...state,
        subjects
      };
    },
    reorder: ({
      subjects
    }) => state => {
      return {
        ...state,
        subjects
      };
    },
    addAttachment: ({
      id,
      attachment
    }) => state => {
      const existing = state.project.subjects.find(s => s.id === id);
      if (!existing) {
        return state;
      }
      existing.attachments.push(attachment);
      const subjects = state.project.subjects.map(s => s.id === id ? existing : s);
      return {
        ...state,
        project: {
          ...state.project,
          subjects
        }
      };
    },
    removeAttachment: ({
      id,
      attachmentId
    }) => state => {
      const existing = state.project.subjects.find(s => s.id === id);
      if (!existing) {
        return state;
      }
      existing.attachments = existing.attachments.filter(attachment => attachment.id !== attachmentId);
      const subjects = state.project.subjects.map(s => s.id === id ? existing : s);
      return {
        ...state,
        project: {
          ...state.project,
          subjects
        }
      };
    }
  }
};
export const initialState = () => ({
  templates: {},
  subjects: [],
  jurisdictions: [],
  subjectTypes: [],
  project: {},
  selectedTemplate: null
});